import { render, staticRenderFns } from "./AuditsWithAnomalies.vue?vue&type=template&id=adc76af6&scoped=true&"
import script from "./AuditsWithAnomalies.vue?vue&type=script&lang=ts&"
export * from "./AuditsWithAnomalies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc76af6",
  null
  
)

export default component.exports